import { createStore, applyMiddleware, combineReducers } from "redux";
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import cartReducer from "./reducers/cartReducer";
import productReducer from "./reducers/productReducer";
import checkReducer from "./reducers/checkReducer";
import authReducer from "./reducers/authReducer";
import deliveryReducer from "./reducers/deliveryReducer";
import adsReducer from "./reducers/adsReducer";
import footerReducer from "./reducers/footerReducer";
import aboutReducer from "./reducers/aboutAction";
import filterReducer from "./reducers/filterReducer";
import shuffleReducer from "./reducers/shuffleReducer";

const persistConfig = {
  key: "root",
  storage,

  whitelist: [
    "cart",
    "auth",
    "deli",
    "checkout",
    "ads",
    "footer",
    "about",
    // "shuffle" removed from here — it's persisted separately below with sessionStorage
  ],
  version: 2,
  migrate: (state) => {
    if (state && Array.isArray(state.cart)) {
      return Promise.resolve({
        ...state,
        cart: {
          cartItems: state.cart,
        },
      });
    }
    return Promise.resolve(state);
  },
};

// Separate persist config for shuffle, using sessionStorage
// so it resets when the browser/tab closes instead of persisting forever
const shufflePersistConfig = {
  key: "shuffle",
  storage: storageSession,
};

const rootReducer = combineReducers({
  cart: cartReducer,
  product: productReducer,
  checkout: checkReducer,
  auth: authReducer,
  deli: deliveryReducer,
  ads: adsReducer,
  footer: footerReducer,
  about: aboutReducer,
  filters: filterReducer,
  shuffle: persistReducer(shufflePersistConfig, shuffleReducer),
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };
